import { Brand } from '@src/Branding';
import AxysLogo from '@src/common/assets/axys-star-logo.svg?react';
import NovaLogo from '@src/common/assets/company-star-logo.svg?react';
import Config from '@src/config/Config';

export const Logo = ({ height, width }: { height: number; width: number }) => {
  const brand = Config.VITE_BRAND;

  return brand === Brand.Axys ? (
    <AxysLogo height={height} width={width} />
  ) : (
    <NovaLogo height={height} width={width} />
  );
};
